import { render, staticRenderFns } from "./LabelMaterialEdit.vue?vue&type=template&id=8a56a0c2&"
import script from "./LabelMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./LabelMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports